import type { SVGProps } from 'react';

/**
 * Custom InPost "Courier Pickups" icon (location pin + check badge with a yellow center dot).
 * Not a stock Lucide icon - mirrors the exact artwork from the Figma sidebar design.
 * Strokes inherit the current text color; the center dot keeps the InPost yellow accent.
 */
export function CourierPickupIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M12.9533 8.62333C13.1913 7.97867 13.3333 7.32 13.3333 6.66667C13.3333 5.25218 12.7714 3.89562 11.7712 2.89543C10.771 1.89524 9.41449 1.33333 8 1.33333C6.58551 1.33333 5.22896 1.89524 4.22876 2.89543C3.22857 3.89562 2.66667 5.25218 2.66667 6.66667C2.66667 9.99533 6.35933 13.462 7.59933 14.5327C7.71485 14.6195 7.85547 14.6665 8 14.6665C8.14453 14.6665 8.28515 14.6195 8.40067 14.5327C8.58406 14.374 8.76475 14.2122 8.94267 14.0473" />
      <path
        d="M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z"
        fill="#FFCC05"
        stroke="none"
      />
      <path d="M10.6667 12L12 13.3333L14.6667 10.6667" />
    </svg>
  );
}
